module.exports = __webpack_public_path__ + "img/3.bf743f1c.jpg";